import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

const llmProviderCard = EntityCardBlueprint.make({
  name: 'llm-provider',
  params: {
    filter: {
      kind: 'resource',
      'spec.type': 'llm-provider',
    },
    type: 'info',
    loader: async () => {
      const { ProviderCard } = await import(
        '../../components/vault/ProviderCard'
      );
      return <ProviderCard />;
    },
  },
});

const apiProviderCard = EntityCardBlueprint.make({
  name: 'api-provider',
  params: {
    filter: {
      kind: 'resource',
      'spec.type': 'api-provider',
    },
    type: 'info',
    loader: async () => {
      const { ProviderCard } = await import(
        '../../components/vault/ProviderCard'
      );
      return <ProviderCard />;
    },
  },
});

const credentialCard = EntityCardBlueprint.make({
  name: 'credential',
  params: {
    filter: {
      kind: 'resource',
      'spec.type': 'credential',
    },
    type: 'info',
    loader: async () => {
      const { CredentialCard } = await import(
        '../../components/vault/CredentialCard'
      );
      return <CredentialCard />;
    },
  },
});

const projectCard = EntityCardBlueprint.make({
  name: 'project',
  params: {
    filter: {
      kind: 'component',
      'spec.type': 'project',
    },
    type: 'info',
    loader: async () => {
      const { ProjectCard } = await import(
        '../../components/vault/ProjectCard'
      );
      return <ProjectCard />;
    },
  },
});

export const catalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    llmProviderCard,
    apiProviderCard,
    credentialCard,
    projectCard,
  ],
});
